import { ApiCacheOptions } from '../../shared/api/api-cache-options.model';
import { CertificationActivitySearchDto } from './certification-activity-search.dto';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { Injectable } from '@angular/core';
import { CertificationActivityDto } from './dto/certification-activity.dto';

@Injectable({
  providedIn: 'root',
})
export class CertificationActivityService {
  private _noCache: ApiCacheOptions;

  public constructor(private _apiService: ApiService) {
    this._noCache = this._apiService.getDefaultApiCacheOptionsForNoCache();
  }

  public getCEUsEarnedForProfileId(search: CertificationActivitySearchDto, noCache?: boolean) {
    if (noCache) {
      return this._apiService.getPaged(`Certifications/Activities`, search, this._noCache);
    } else {
      return this._apiService.getPaged(`Certifications/Activities`, search);
    }
  }

  public create(activity: CertificationActivityDto) {
    return this._apiService.post('Certifications/Activities', activity);
  }

  public update(activity: CertificationActivityDto) {
    return this._apiService.put(`Certifications/Activity/${activity.CertificationActivityID}`, activity);
  }

  public delete(id: number) {
    return this._apiService.delete(`Certifications/Activity/${id}`);
  }
}
